import { replace } from 'connected-react-router';
import { put, take } from 'redux-saga/effects';

import type { SagaIterator } from '@redux-saga/types';

import {
  CLOSE_SIGNING_DIALOG,
  OPEN_LOGIN_DIALOG,
  OPEN_SIGN_DIALOG,
} from 'app/modules/Signing/actions';
import { createAuthQuery } from 'app/modules/Signing/utils/auth-modals-query';

export default function* displayModalSaga(): SagaIterator {
  while (true) {
    const action = yield take([
      OPEN_LOGIN_DIALOG,
      OPEN_SIGN_DIALOG,
      CLOSE_SIGNING_DIALOG,
    ]);

    switch (action.type) {
      case OPEN_LOGIN_DIALOG:
        yield put(replace({ search: createAuthQuery('login') }));
        break;

      case OPEN_SIGN_DIALOG:
        yield put(replace({ search: createAuthQuery('sign') }));
        break;

      case CLOSE_SIGNING_DIALOG:
        yield put(replace({ search: createAuthQuery('close') }));
        break;
    }
  }
}
